export type LiteLocale = 'zh-CN' | 'en-US';

export const LITE_LOCALE_STORAGE_KEY = 'lite-page-locale';

export const liteCopy = {
  'zh-CN': {
    language: {
      zh: '中文',
      en: 'EN',
    },
    metaTitle: '有数｜人生说明书 - 看完，你心里就有数了',
    exportName: '人生说明书',
    brandName: '有数',
    slogan: '看完，你心里就有数了',
    heroTitle: '人生说明书',
    heroSubtitle: '围绕你现在最想问的问题，帮你看清当下状态、今年趋势和下一步重点。',
    topicEntryTitle: '去专题里选',
    topicEntryDesc: '如果你更想直接看事业、合盘或孩子天赋，这里可以先进去选一个专题。',
    topicEntryAction: '选择专题',
    form: {
      birthTimeLabel: '出生时间',
      birthTimeRequired: '请选择出生时间',
      genderLabel: '性别',
      genderRequired: '请选择性别',
      genderPlaceholder: '请选择性别',
      male: '男',
      female: '女',
      cityLabel: '出生城市',
      cityRequired: '请选择出生城市',
      cityDomestic: '国内',
      cityOverseas: '海外',
      cityDomesticPlaceholder: '请选择国内城市',
      cityOverseasPlaceholder: '请选择海外城市',
      cityOverseasHint: '当前海外城市仅支持北半球国家与地区。',
      questionLabel: '你现在最想问什么',
      questionRequired: '请填写你现在最想问什么',
      questionPlaceholder: '把你现在最困扰、最想看明白的问题写下来，报告会优先围绕它展开。',
      questionHint: '必填。比如：我今年适不适合换工作？感情为什么总卡住？最近为什么特别累？',
      pastEventsTitle: '前事验证',
      pastEventsBadge: '强烈建议填写',
      pastEventsLead: '这一步会明显提高 AI 对喜用和整体判断的准确度，强烈建议你至少补 1-3 条已经发生过的前事。',
      pastEventsLead2: '你可以优先补这 3 类信息：1. 哪年明显更顺；2. 哪年明显更卡；3. 那年发生了什么变化。',
      pastEventsLead3: '我们会先把年份换成对应流年干支，再交给 AI 综合判断。',
      pastEventsExamplesTitle: '最好直接照着这 3 种方式填，AI 会更容易判断准：',
      pastEventsExample1: '1. 哪年更顺：比如“2023 年工作推进很顺，机会明显变多”',
      pastEventsExample2: '2. 哪年更卡：比如“2024 年情绪很差，关系和工作都容易卡住”',
      pastEventsExample3: '3. 那年发生了什么变化：比如“2022 年搬家换城市，之后整个人状态变了”',
      yearPlaceholder: '年份',
      yearRequired: '请选择年份',
      eventPlaceholder: '比如：工作推进很顺，收入提升明显；或者那年状态很差，总失眠内耗。',
      eventRequired: '请填写这年发生了什么',
      addPastEvent: '添加一条前事（建议至少 1 条）',
      distinguishZiShi: '区分早晚子时',
      ziShiTooltipTitle: '子时日柱计算规则（真太阳时）：',
      ziShiTraditional: '传统算法（默认）：',
      ziShiTraditionalDesc: '23:00-01:00 统一算第二天',
      ziShiModern: '现代算法（勾选后）：',
      ziShiModernDesc1: '23:00-00:00 算当天（早子时）',
      ziShiModernDesc2: '00:00-01:00 算第二天（晚子时）',
      generateBasic: '生成基础画像',
      reset: '重置',
      disclaimer: '免责声明：本页内容仅供娱乐与个人参考，不构成任何现实决策、医疗、法律或财务建议。',
    },
    baseProfile: {
      title: '你的基础画像',
      solarLabel: '公历（北京时间）',
      unknownHour: '时辰未知',
      trueSolarLabel: '真太阳时',
      lunarLabel: '农历',
      generateAnalysis: '生成我的分析',
      hourRequiredHint: '需要先补充出生时辰，才能生成完整报告。时辰就是出生落在哪个两小时段里，比如子时是 23:00-01:00，丑时是 01:00-03:00。',
    },
    report: {
      title: '你的当下分析',
      save: '保存这份分析',
      saveFull: '保存完整分析',
      share: '生成摘要卡',
      tipTitle: '这份分析更适合慢慢看，不用一次读完',
      tipDesc: '你可以先保存下来，等安静一点的时候再回来慢慢看。',
      wuxingTitle: '喜用判断',
      wuxingLabel: 'AI综合判断',
      wuxingFallback: '如果你补充了前事，AI 会把这些已发生的年份线索和命盘一起综合来看。',
      productBadge: '顺手给你的对路支持物',
      productSearchLead: '想找同款日常支持物',
      productSearchHint: '抖音 / 小红书 搜索「赤松仙」',
    },
    shareCard: {
      brandEyebrow: '有数 · 人生说明书',
      fileName: '人生说明书_摘要卡.png',
      saving: '正在生成图片，请稍后...',
      mobileSaved: '图片已生成，请长按保存',
      saved: '图片保存成功！',
      failed: '图片保存失败，请重试',
      mobileTitle: '长按下方图片保存到相册',
      mobileHint: '可上下滑动查看完整内容',
      mobileDownload: '直接下载图片',
      mobileClose: '关闭预览',
      summaryTab: '摘要卡片',
      posterTab: '分享海报',
      summaryTitle: '人生说明书摘要',
      summaryYearHint: '年给自己的提醒',
      baseLabel: '你的底色',
      yearLabel: '今年关键词',
      posterYearLabel: '年度',
      posterTraitsLabel: '性格特质',
      posterYearTrendLabel: '年度运势',
      saveImage: '保存图片',
      qrHint: '扫码获取你的人生说明书',
      footer: '基于八字+紫微斗数 AI 分析',
    },
    toast: {
      selectBirth: '请选择出生日期和时间',
      invalidLongitude: '请输入有效的经度，例如 116.4',
      finishChartFirst: '请先完成排盘',
      needHour: '生成完整报告至少需要知道出生时辰。时辰就是出生落在哪个两小时段里，比如子时、丑时、寅时。',
      fillQuestion: '请先填写你现在最想问什么',
      reportFailed: '人生说明书生成失败',
      reportGenerated: '人生说明书已生成',
      retry: '生成失败，请稍后重试',
    },
    shareFallback: {
      personalityTags: ['命盘待生成'],
      yearKeywords: ['等待解读'],
      oneLiner: '你的人生说明书生成后，这里会自动提炼出最适合分享的摘要。',
      focusLabel: '你最值得记住的',
      defaultFocus: '你今年最值得留意的',
      careerFocus: '你今年事业上最值得记住的',
      relationshipFocus: '你今年关系里最值得记住的',
      wealthFocus: '你今年财务上最值得记住的',
      healthFocus: '你今年状态上最值得记住的',
      generalFocus: '你今年最值得记住的',
      oneLinerPrefix: '一句话',
      closingPrefixRegex: '^你要记住[:：]?\\s*',
      careerOneLiner: '今年事业上最重要的，不是急着证明自己，而是先把方向和节奏对准，再发力。',
      relationshipOneLiner: '今年感情里最重要的，不是抓紧谁，而是先看清谁真的适合你。',
      wealthOneLiner: '今年财务上更适合先稳住底盘，别被短期波动带着跑。',
      healthOneLiner: '你现在最需要的不是硬撑，而是先把状态一点点养回来。',
      actionOneLiner: '今年不是你缩着过的一年，关键是把劲用在真正值得的地方。',
      defaultYearKeyword: '先稳住自己',
      generalOneLinerPrefix: '今年更适合',
      generalOneLinerSuffix: '，别急着求结果，先把节奏站稳。',
    },
  },
  'en-US': {
    language: {
      zh: '中文',
      en: 'EN',
    },
    metaTitle: 'Youshu | Life Manual - Clarity for What Comes Next',
    exportName: 'Life Manual',
    brandName: 'Youshu',
    slogan: 'Read it once, and things start to feel clearer.',
    heroTitle: 'Life Manual',
    heroSubtitle: 'Built around the question you care about most, helping you see your current state, this year’s trend, and your next priority.',
    topicEntryTitle: 'Choose a topic first',
    topicEntryDesc: 'If you want to jump straight into career, compatibility, or child talent, you can start from a dedicated topic.',
    topicEntryAction: 'Browse topics',
    form: {
      birthTimeLabel: 'Birth Time',
      birthTimeRequired: 'Please select birth time',
      genderLabel: 'Gender',
      genderRequired: 'Please select gender',
      genderPlaceholder: 'Please select gender',
      male: 'Male',
      female: 'Female',
      cityLabel: 'Birth City',
      cityRequired: 'Please select a birth city',
      cityDomestic: 'China',
      cityOverseas: 'Overseas',
      cityDomesticPlaceholder: 'Select a city in China',
      cityOverseasPlaceholder: 'Select an overseas city',
      cityOverseasHint: 'Overseas cities currently support Northern Hemisphere countries and regions only.',
      questionLabel: 'What do you most want to ask right now?',
      questionRequired: 'Please tell us what you most want to ask',
      questionPlaceholder: 'Write down the issue that feels most confusing or urgent right now. The report will prioritize it.',
      questionHint: 'Required. For example: Is this year good for changing jobs? Why does my relationship keep getting stuck? Why have I been so tired lately?',
      pastEventsTitle: 'Past Event Verification',
      pastEventsBadge: 'Strongly Recommended',
      pastEventsLead: 'This step can noticeably improve the accuracy of the AI’s judgment on favorable elements and the overall reading.',
      pastEventsLead2: 'We strongly recommend adding at least 1-3 events that already happened: 1. a year that felt smoother; 2. a year that felt harder; 3. a year when something clearly changed.',
      pastEventsLead3: 'We will first convert the year into its corresponding sexagenary cycle, then let the AI use it as evidence.',
      pastEventsExamplesTitle: 'The easiest way is to follow one of these three patterns:',
      pastEventsExample1: '1. A smoother year: for example, “In 2023, work moved forward easily and opportunities increased.”',
      pastEventsExample2: '2. A harder year: for example, “In 2024, I felt emotionally drained and both work and relationships got stuck.”',
      pastEventsExample3: '3. A year of change: for example, “In 2022, I moved to a new city and my whole state shifted after that.”',
      yearPlaceholder: 'Year',
      yearRequired: 'Please select a year',
      eventPlaceholder: 'For example: work went smoothly and income improved; or that year I felt exhausted and kept losing sleep.',
      eventRequired: 'Please describe what happened that year',
      addPastEvent: 'Add one past event (at least 1 is recommended)',
      distinguishZiShi: 'Distinguish early/late Zi hour',
      ziShiTooltipTitle: 'Zi-hour day-pillar rule (true solar time):',
      ziShiTraditional: 'Traditional rule (default):',
      ziShiTraditionalDesc: '23:00-01:00 is counted as the next day',
      ziShiModern: 'Modern rule (when enabled):',
      ziShiModernDesc1: '23:00-00:00 counts as the same day (early Zi hour)',
      ziShiModernDesc2: '00:00-01:00 counts as the next day (late Zi hour)',
      generateBasic: 'Generate Base Chart',
      reset: 'Reset',
      disclaimer: 'Disclaimer: This page is for entertainment and personal reference only. It does not constitute medical, legal, financial, or real-world decision advice.',
    },
    baseProfile: {
      title: 'Your Base Chart',
      solarLabel: 'Gregorian (Beijing Time)',
      unknownHour: 'Hour unknown',
      trueSolarLabel: 'True Solar Time',
      lunarLabel: 'Lunar',
      generateAnalysis: 'Generate My Reading',
      hourRequiredHint: 'You need a confirmed birth hour before generating the full report. A shichen is a two-hour birth block, such as Zi hour (23:00-01:00) or Chou hour (01:00-03:00).',
    },
    report: {
      title: 'Your Current Reading',
      save: 'Save This Reading',
      saveFull: 'Save Full Reading',
      share: 'Create Summary Card',
      tipTitle: 'This reading is better absorbed slowly, not all at once',
      tipDesc: 'You can save it now and come back when you have a quieter moment.',
      wuxingTitle: 'Favorable Element Judgment',
      wuxingLabel: 'AI Judgment',
      wuxingFallback: 'If you added past events, the AI will read those year-based clues together with your chart.',
      productBadge: 'A support piece picked for your current path',
      productSearchLead: 'Looking for the same everyday support piece?',
      productSearchHint: 'Search "Chisongxian" on Douyin / RED',
    },
    shareCard: {
      brandEyebrow: 'Youshu · Life Manual',
      fileName: 'life-manual-summary-card.png',
      saving: 'Generating image, please wait...',
      mobileSaved: 'Your image is ready. Press and hold to save it.',
      saved: 'Image saved successfully!',
      failed: 'Failed to save image. Please try again.',
      mobileTitle: 'Press and hold the image below to save it',
      mobileHint: 'You can scroll up and down to view the full card',
      mobileDownload: 'Download Image',
      mobileClose: 'Close Preview',
      summaryTab: 'Summary Card',
      posterTab: 'Share Poster',
      summaryTitle: 'Life Manual Summary',
      summaryYearHint: 'Reminder to yourself for',
      baseLabel: 'Your Core Tone',
      yearLabel: 'This Year’s Keywords',
      posterYearLabel: 'Annual Snapshot',
      posterTraitsLabel: 'Personality Traits',
      posterYearTrendLabel: 'Yearly Trend',
      saveImage: 'Save Image',
      qrHint: 'Scan to get your Life Manual',
      footer: 'AI reading based on Bazi + Zi Wei Dou Shu',
    },
    toast: {
      selectBirth: 'Please select birth date and time',
      invalidLongitude: 'Please enter a valid longitude, for example 116.4',
      finishChartFirst: 'Please finish chart generation first',
      needHour: 'A confirmed birth hour is required for the full report. A shichen is a two-hour birth block, such as Zi, Chou, or Yin hour.',
      fillQuestion: 'Please tell us what you most want to ask first',
      reportFailed: 'Failed to generate the Life Manual',
      reportGenerated: 'Your Life Manual is ready',
      retry: 'Generation failed. Please try again later.',
    },
    shareFallback: {
      personalityTags: ['Chart not generated yet'],
      yearKeywords: ['Waiting for reading'],
      oneLiner: 'Once your Life Manual is generated, we will automatically extract a shareable summary here.',
      focusLabel: 'What matters most for you',
      defaultFocus: 'What is most worth noticing for you this year',
      careerFocus: 'What is most worth remembering in your career this year',
      relationshipFocus: 'What is most worth remembering in your relationships this year',
      wealthFocus: 'What is most worth remembering financially this year',
      healthFocus: 'What is most worth remembering about your state this year',
      generalFocus: 'What is most worth remembering for you this year',
      oneLinerPrefix: 'In one line',
      closingPrefixRegex: '^Remember this[:：]?\\s*',
      careerOneLiner: 'What matters most in your career this year is not proving yourself quickly, but aligning your direction and pace before pushing harder.',
      relationshipOneLiner: 'What matters most in love this year is not holding on tighter, but seeing clearly who is truly right for you.',
      wealthOneLiner: 'Financially, this year is better for stabilizing your base first instead of reacting to short-term swings.',
      healthOneLiner: 'What you need most right now is not to force yourself through, but to rebuild your energy little by little.',
      actionOneLiner: 'This is not a year to shrink back. The key is to spend your energy on what is truly worth it.',
      defaultYearKeyword: 'steady yourself first',
      generalOneLinerPrefix: 'This year is better for ',
      generalOneLinerSuffix: '. Do not rush the outcome. Stand firmly in your rhythm first.',
    },
  },
} as const;

export function getLiteCopy(locale: LiteLocale) {
  return liteCopy[locale];
}
